"use client";

import { validateSessionWithoutRedirect } from "@/actions/auth";

import {
  createContext,
  useState,
  useContext,
  useCallback,
  useEffect,
} from "react";

const AuthContext = createContext({
  user: null,
  setUser: () => null,
  loading: false,
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const validateUser = useCallback(async () => {
    setLoading(true);
    try {
      const { user } = await validateSessionWithoutRedirect();
      setUser(user);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
